module.exports = __webpack_public_path__ + "09b18327.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/static/bannerDefault.png
// module id = 941
// module chunks = 2 3